import { FC } from 'react';
import { useGet } from '../../hooks/useApi';
import { notificationsAPI } from '../../APIs/notificationsAPI';
import { reformat } from '../../utils/DateUtils';
import { Link } from 'react-router';

import { Icon, Icons } from '../atomic/icons';
import { NotificationModel } from '../../models/NotificationModel';
import { NotificationLabel } from '../notification/NotificationLabel';
type Prop = {};
export const LoginNotificationComponent: FC<Prop> = () => {
    const {
        data: notifications,
        isLoading,
        error,
    } = useGet(notificationsAPI.public.get());

    if (isLoading) {
        return <></>;
    }
    if (error) {
        console.warn('Error while loading notifications', error);
        return <></>;
    }
    return (
        <>
            {notifications && notifications?.data.length > 0 && (
                <>
                    <ul className="notification login-notifications">
                        {notifications.data.slice(0, 3).map((notification) => {
                            return (
                                <NotificationRow
                                    key={notification.notificationId}
                                    notification={notification}
                                    isPublic={true}
                                />
                            );
                        })}
                    </ul>
                    <Link to={`/app/notifications`}>お知らせ一覧</Link>
                </>
            )}
        </>
    );
};
type RawProp = {
    notification: NotificationModel;
    isPublic?: boolean;
};
const NotificationRow: FC<RawProp> = ({ notification, isPublic }) => {
    const url = isPublic
        ? `/app/public/notification/${notification.notificationId}`
        : `/app/notification/${notification.notificationId}`;
    return (
        <li key={notification.notificationId} className="list">
            <span className="datetime">{reformat(notification.updatedAt)}</span>
            <NotificationLabel type={notification.notificationType} />
            {notification.content ? (
                <>
                    <Link key={notification.notificationId} to={url}>
                        <p className="title">
                            {notification.title}
                            <Icon icon={Icons.Link} />
                        </p>
                    </Link>
                </>
            ) : (
                <p className="title">{notification.title}</p>
            )}
        </li>
    );
};
